import styled, { keyframes, css } from 'styled-components';
import Notice from '@bufferapp/ui/Notice';

export const CalendarPage = styled.main`
  padding: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const navigateRight = keyframes`
  0% {
    margin-left: 25px;
  }

  100% {
    margin-left: 0;
  }
`;

const navigateLeft = keyframes`
  0% {
    margin-left: -25px;
  }

  100% {
    margin-left: 0;
  }
`;

export const CalendarGrid = styled.div`
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
`;

export const CalendarTable = styled.table`
  position: relative;
  height: 100%;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  box-sizing: border-box;
  ${(props) =>
    props.showRightAnimation &&
    css`
      animation: ${navigateRight} 0.2s;
    `}
  ${(props) =>
    props.showLeftAnimation &&
    css`
      animation: ${navigateLeft} 0.2s;
    `}
`;

export const CalendarHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const CalendarHeaderRightSide = styled.span`
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    margin-right: 8px;
  }
`;

export const CalendarNotice = styled(Notice)`
  margin-bottom: 16px;
`;
